const revealLazyMedia = () => {
  document.querySelectorAll('img[loading="lazy"]').forEach((el) => {
    el.loading = 'eager';
    el.classList.add('in-view');
  });

  document.querySelectorAll('video.lazy, [data-animate]').forEach((el) => {
    el.classList.add('in-view');
  });
};

const initLazyLoad = () => {
  if (window.Shopify?.designMode) {
    revealLazyMedia();
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const { target, isIntersecting } = entry;
      const { animate } = target.dataset;
      isIntersecting && target.classList.add('in-view');
      animate && setTimeout(() => target.classList.remove('in-view'), Number(animate));
    });
  }, {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: [0.5, 1.0],
  });

  document.querySelectorAll('img[loading="lazy"]').forEach((el) => {
    const isLoaded = el.complete && el.naturalHeight !== 0;
    isLoaded ? observer.observe(el) : (el.onload = () => observer.observe(el));
  });

  document.querySelectorAll('video.lazy').forEach((el) => observer.observe(el));

  document.querySelectorAll('[data-animate]').forEach((el) => {
    observer.observe(el);
  });
};

const startLazyLoad = () => {
  document.body.classList.add('ready');
  initLazyLoad();
};

window.initLazyLoad = initLazyLoad;

document.addEventListener('shopify:section:load', initLazyLoad);

if (document.readyState === 'complete') {
  startLazyLoad();
} else {
  document.addEventListener('readystatechange', () => {
    if (document.readyState === 'complete') {
      startLazyLoad();
    }
  });
}
